import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { notificationsApi } from "@/api/client";

export function NotificationBell({ testid }) {
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  const load = () => notificationsApi.list({ size: 1 }).then((r) => setUnread(r.data.unread || 0)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <button data-testid={testid || "notification-bell"} onClick={() => navigate("/notifications")}
      className="relative flex h-10 w-10 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100" aria-label="Notifications">
      <Bell className="h-5 w-5" />
      {unread > 0 && (
        <span data-testid="notification-unread-badge" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-rose-600 px-1 text-[10px] font-bold text-white">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}
